// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M20.203.3c-.36.09-.165-.09-3.607 3.35-1.743 1.741-3.181 3.166-3.198 3.166a.338.338 0 0 1-.107-.048c-.223-.138-.657-.187-.933-.106-.332.098-.298.067-2.218 1.98l-1.8 1.792-.168-.08a1.233 1.233 0 0 0-1.092.005c-.175.084-.26.166-2.793 2.694-1.437 1.434-2.675 2.685-2.751 2.78-.372.462-.475 1.043-.289 1.641.11.355.033.272 2.916 3.162 1.479 1.483 2.754 2.742 2.833 2.799.193.138.308.194.532.257.223.064.66.075.872.024.227-.056.55-.227.744-.395.099-.086 1.337-1.315 2.751-2.732 2.495-2.5 2.574-2.582 2.658-2.757.172-.356.173-.741.002-1.103l-.085-.178 1.808-1.814c1.359-1.362 1.825-1.843 1.873-1.935.185-.354.183-.844-.006-1.174l-.069-.12 1.673-1.68c1.807-1.815 1.782-1.787 1.918-2.184l.065-.192.006-3.036c.005-2.126-.001-3.074-.02-3.162a1.371 1.371 0 0 0-.576-.806c-.272-.158-.66-.22-.94-.148m-2.844 4.698c-1.574 1.574-2.862 2.873-2.862 2.886 0 .032 2.5 2.532 2.533 2.532.013 0 .738-.715 1.61-1.59 1.322-1.324 1.59-1.604 1.602-1.671.022-.116.019-5.019-.003-5.019-.01 0-1.306 1.288-2.88 2.862m-6.306 4.866L9.42 11.496l1.998 1.998 1.998 1.998 1.638-1.638 1.638-1.638-1.992-1.992a235.78 235.78 0 0 0-2.004-1.992c-.007 0-.746.734-1.644 1.632m-5.904 4.464c-2.373 2.374-2.484 2.488-2.484 2.57 0 .058.023.118.07.18.038.052 1.207 1.23 2.598 2.619 1.722 1.72 2.549 2.53 2.594 2.54a.333.333 0 0 0 .132 0c.045-.01.847-.798 2.538-2.492l2.473-2.477-2.719-2.712-2.718-2.713-2.484 2.485"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const BeautySalonIcon = Icon;
export default BeautySalonIcon;
